import { Actions, createStore } from '@bpd-library/utilities';

export type SDPServiceName = 'vimeo' | 'youtube' | 'mapbox';
export type ServiceConsentState = Record<SDPServiceName, boolean>;

type ConsentStoreAction = 'updateServiceConsent';

const initialState: ServiceConsentState = {
    mapbox: false,
    vimeo: false,
    youtube: false,
};

const actions: Actions<ConsentStoreAction, ServiceConsentState> = {
    updateServiceConsent: (
        state: ServiceConsentState,
        { mapbox, vimeo, youtube }: ServiceConsentState,
    ) => {
        state.mapbox = mapbox;
        state.vimeo = vimeo;
        state.youtube = youtube;
        return state;
    },
};

export const serviceConsentStore = createStore<ServiceConsentState, ConsentStoreAction>({
    initialState,
    actions,
});

export const updateServiceConsent = (consentState: ServiceConsentState) => {
    serviceConsentStore.dispatch('updateServiceConsent', consentState);
};

export const hasConsent = (service: SDPServiceName) => serviceConsentStore.getState()[service];
